import React, { FC, ReactNode } from 'react'
import { FormAppControl } from './styled'
interface AppFormControlProps {
	children?: ReactNode
	error?: boolean
	color?:
		| 'primary'
		| 'secondary'
		| 'error'
		| 'info'
		| 'success'
		| 'warning'
		| undefined
	sx?: object
	margin?: 'dense' | 'none' | 'normal' | undefined
	absoluteError?: boolean
}

const AppFormControl: FC<AppFormControlProps> = ({
	children,
	error,
	sx,
	margin,
	color,
	absoluteError,
}: AppFormControlProps) => {
	return (
		<FormAppControl
			error={error}
			sx={sx}
			margin={margin}
			color={color}
			absoluteError={!absoluteError}
		>
			{children}
		</FormAppControl>
	)
}

export default AppFormControl
